/**
 * Türkiye cep: kayıt için 11 haneli yerel biçim (05XXXXXXXXX, yalnızca rakam).
 * Girdi: +90..., 90..., 0..., 5... (10 hane) vb.
 */
export function normalizeTrCepToLocal11(input) {
  if (input == null || input === "") return "";
  let d = String(input).replace(/\D/g, "");
  if (d.length >= 12 && d.startsWith("90")) {
    d = "0" + d.slice(-10);
  } else if (d.length === 10 && d.startsWith("5")) {
    d = "0" + d;
  }
  if (d.length > 11) d = d.slice(0, 11);
  return d;
}

/**
 * Görüntü: 05XX XXX XX XX (şifremi unuttum ve kayıt öncesi düzenleme alanlarında).
 * Kısmi yazım sırasında da boşluklarla ayrılır.
 */
export function formatTrCepDisplay(input) {
  const d = normalizeTrCepToLocal11(input);
  if (!d) return "";
  if (d.length <= 4) return d;
  if (d.length <= 7) return `${d.slice(0, 4)} ${d.slice(4)}`;
  if (d.length <= 9) return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7)}`;
  return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7, 9)} ${d.slice(9, 11)}`;
}

/**
 * Kayıtlı personel kartı / salt okunur: aralıksız normal numara (05XXXXXXXXX).
 */
export function formatTrCepStoredDisplay(input) {
  const d = normalizeTrCepToLocal11(input);
  return d || "";
}
